import React from "react";
import {
  MagnifyingGlassIcon,
  ChevronDownIcon,
  PlusIcon,
  EyeIcon
} from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import lotImage from './../../../assets/images/lot.png';
import { useTranslation } from "../../../contexts/LanguageContext";

const lots = [
  {
    id: 1,
    name: ' Iphone 14 pro',
    buyNowPrice: '60 KD',
    reservePrice: '40 KD',
    bidIncrement: '5 KD',
    averageBid: '60 LD',
    totalBids: 200,
    status: 'Sold'
  },
  {
    id: 2,
    name: ' Iphone 14 pro',
    buyNowPrice: '60 KD',
    reservePrice: '40 KD',
    bidIncrement: '5 KD',
    averageBid: '60 LD',
    totalBids: 200,
    status: 'Sold'
  },
  {
    id: 3,
    name: ' Iphone 14 pro',
    buyNowPrice: '60 KD',
    reservePrice: '40 KD',
    bidIncrement: '5 KD',
    averageBid: '60 LD',
    totalBids: 200,
    status: 'Sold'
  },
  {
    id: 4,
    name: ' Iphone 14 pro',
    buyNowPrice: '60 KD',
    reservePrice: '40 KD',
    bidIncrement: '5 KD',
    averageBid: '60 LD',
    totalBids: 200,
    status: 'Sold'
  }
];

export default function AllLots({title}) {
  const { t, tStatus } = useTranslation();

  return (
    <div>
      <div className="bg-white rounded-[10px] border border-dashboardStroke shadow-[0px_9px_15px_rgba(0,0,0,0.07)] overflow-hidden">
        {/* Dark Header */}
        <div className="bg-dashboardDark h-16 px-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <h2 className="text-white font-semibold text-lg">{t("lots.title")}</h2>
            <span className="text-white font-semibold">99023</span>
          </div>

          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2 px-3 py-1.5 border border-white rounded">
              <MagnifyingGlassIcon className="w-[18px] h-[18px] text-white" />
              <input
                type="text"
                placeholder={t("lots.searchPlaceholder")}
                className="bg-transparent text-white placeholder-white/70 text-sm font-light outline-none w-28"
              />
            </div>

            <button className="flex items-center gap-2 px-3 py-1.5 border border-white rounded text-white text-sm font-light">
              <span>{t("lots.sortBy")}</span>
              <ChevronDownIcon className="w-[18px] h-[18px] text-themeLightGray" />
            </button>

            <button className="flex items-center gap-2 px-4 py-1.5 bg-dashboardCoral rounded text-white text-sm font-medium">
              <PlusIcon className="w-[18px] h-[18px]" />
              <span>{t("lots.addNew")}</span>
            </button>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-dashboardStroke">
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">{t("lots.col.image")}</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">{t("lots.col.name")}</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">{t("lots.col.buyNowPrice")}</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">{t("lots.col.reserveAmount")}</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">{t("lots.col.bidIncrement")}</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">{t("lots.col.average")}</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">{t("lots.col.bids")}</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">{t("lots.col.status")}</th>
                <th className="px-4 py-4 text-left text-[17px] font-medium text-dashboardText">{t("lots.col.actions")}</th>
              </tr>
            </thead>
            <tbody>
              {lots.map((lot, index) => (
                <tr
                  key={lot.id + '-' + index}
                  className={`border-b border-dashboardStroke hover:bg-gray-50 transition-colors ${
                    index === 0 ? "shadow-[inset_3px_0px_0px_#FF7C17]" : ""
                  }`}
                >
                  <td className="px-4 py-4 whitespace-nowrap">
                    <img src={lotImage} alt="Lot" className="h-12 w-12 object-cover rounded" />
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-base font-normal text-dashboardDarkText">
                    {lot.name}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-base font-medium text-dashboardCoral">
                    {lot.buyNowPrice}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-base font-normal text-dashboardDarkText">
                    {lot.reservePrice}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-base font-normal text-dashboardDarkText">
                    {lot.bidIncrement}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-base font-normal text-dashboardDarkText">
                    {lot.averageBid}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-base font-normal text-dashboardDarkText">
                    {lot.totalBids}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap">
                    <span className={`inline-flex items-center px-2.5 py-1 text-xs font-medium rounded-full ${
                      lot.status === 'Sold' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                    }`}>
                      <span className={`inline-block w-2 h-2 rounded-full mr-1.5 ${
                        lot.status === 'Sold' ? 'bg-green-500' : 'bg-yellow-500'
                      }`} />
                      {tStatus(lot.status)}
                    </span>
                  </td>
                  <td className="px-4 py-4">
                    <Link
                      to={'/auctions/'+lot.id}
                      className="p-1 hover:bg-gray-100 rounded transition-colors inline-flex"
                    >
                      <EyeIcon className="w-6 h-6 text-dashboardDark" strokeWidth={1.3} />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
